module.exports = __webpack_public_path__ + "img/bmcl_gallery15.14843fee.jpg";